import React from "react";
import useReveal from "../hooks/useReveal";

interface Props {
  children: React.ReactNode;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
  delay?: number;
}

// Scroll-triggered fade/slide-up wrapper, mirrors the mockup's .reveal
// class + IntersectionObserver.
const Reveal = ({ children, className = "", as: Tag = "div", delay }: Props) => {
  const { ref, isVisible } = useReveal();

  const Component = Tag as any;

  return (
    <Component
      ref={ref}
      className={`hv2-reveal ${isVisible ? "hv2-reveal--visible" : ""} ${className}`}
      style={delay ? { transitionDelay: `${delay}s` } : undefined}
    >
      {children}
    </Component>
  );
};

export default Reveal;
